export default __webpack_public_path__ + "navigation-overview-setup-ib-960-c9a86f3e36278d2d7e749d135999e5f8.png";